"use client";

import * as React from "react";

import { SidebarContext, type SidebarConfig } from "./sidebarContextStore";

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = React.useState<SidebarConfig>({
    variant: "inset",
    collapsible: "offcanvas",
    side: "left",
  });

  const updateConfig = React.useCallback((newConfig: Partial<SidebarConfig>) => {
    setConfig((prev) => ({ ...prev, ...newConfig }));
  }, []);

  return <SidebarContext.Provider value={{ config, updateConfig }}>{children}</SidebarContext.Provider>;
}

export type { SidebarConfig, SidebarContextValue } from "./sidebarContextStore";
